import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { scrollToId } from "@/lib/api";

export const useLenis = () => {
  const { hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash), 350);
      return () => clearTimeout(t);
    }
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [hash]);
};
